export const selectTasks = state => state.tasks.tasks;
export const selectIsLoading = state => state.tasks.isLoading;
export const selectError = state => state.tasks.error;
